import type {
  CreateVisitorDto,
  SportQuestionsResponseDto,
  SportResponseDto,
  SubmitDigestPreferencesDto,
} from '@nomiss/sdk';
import { executeSdkRawRequest } from './api-request.util';
import { onboardingApi } from './sdk-client';

export type VisitorSessionInfo = {
  visitorId: string;
  expiresAt: string;
};

export async function listSports(): Promise<SportResponseDto[]> {
  const data = await executeSdkRawRequest<SportResponseDto[]>({
        request: () => onboardingApi.onboardingControllerListSportsV1Raw({}),
    fallback: 'Failed to load sports',
  });

  return Array.isArray(data) ? data : [];
}

export async function getSportQuestions(
  sport: string,
): Promise<SportQuestionsResponseDto> {
  return executeSdkRawRequest({
    request: () =>
      onboardingApi.onboardingControllerGetQuestionsBySportV1Raw({ sport }),
    fallback: 'Failed to load sport questions',
  });
}

export async function getPostSportDigestFlow(): Promise<unknown> {
  return executeSdkRawRequest({
    request: () =>
      onboardingApi.onboardingControllerGetPostSportDigestFlowV1Raw(),
    fallback: 'Failed to load post-sport digest',
  });
}

export async function submitDigestPreferences(
  visitorId: string,
  dto: SubmitDigestPreferencesDto,
): Promise<unknown> {
  return executeSdkRawRequest({
    request: () =>
      onboardingApi.onboardingControllerSubmitDigestPreferencesV1Raw({
        xVisitorId: visitorId,
        submitDigestPreferencesDto: dto,
      }),
    fallback: 'Failed to submit digest preferences',
  });
}

export async function createVisitor(
  dto: CreateVisitorDto,
): Promise<VisitorSessionInfo> {
  const data = await executeSdkRawRequest<VisitorSessionInfo>({
    request: () =>
      onboardingApi.onboardingControllerCreateVisitorV1Raw({
        createVisitorDto: dto,
      }),
    fallback: 'Failed to create visitor session',
  });

  if (!data.visitorId) {
    throw new Error('Visitor session response missing visitorId');
  }

  return data;
}
